// extracted by mini-css-extract-plugin
module.exports = {"chip-area":"_1FJRx","chip-image":"_3rcnS","chip-title":"_3mejb"};